import axios from "axios";
import cachios from "cachios";
import {onRequest} from "./createAxiosInstance";
import Cookies from "universal-cookie";
const cookies = new Cookies();
const baseUrl =
  window._env_?.REACT_APP_BASE_URL || process.env.REACT_APP_BASE_URL;
const cacheAxiosInstance = axios.create({
    baseURL: baseUrl,
    headers: {
        'Accept-Language': 'fa',
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Bearer ${cookies.get("token")}`
    }
});

// cacheAxiosInstance.interceptors.request.use(onRequest, null);

export const cachiosInstance = cachios.create(cacheAxiosInstance);
